import { Box, Typography, Grid, Paper, TextField, Button, Stack, Avatar, Chip } from '@mui/material';
import React, { useState, useEffect, useCallback } from 'react'
import { FaUserAlt, FaCalendar, FaClock, FaSuitcaseRolling } from "react-icons/fa";
import { IoMdMail } from "react-icons/io";
import { MdFamilyRestroom, MdLock } from "react-icons/md";
import { FaReceipt } from "react-icons/fa6";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import 'dayjs/locale/de';

import { useAuth } from '../provider/auth';
import axios from 'axios';
import { toast } from 'react-toastify';
import ShowBookingModal from '../components/ShowBookingModal';
import { GiTennisCourt } from "react-icons/gi";
import { RiMoneyEuroCircleFill } from "react-icons/ri";
import { API_BASE_URL } from '../App.js';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Europe/Berlin");

const Account = () => {
    const { user } = useAuth();
    const [changePassword, setChangePassword] = useState(false)
    const [profile, setProfile] = useState({});
    const [upcomingBookings, setUpcomingBookings] = useState([]);
    const [pastBookings, setPastBookings] = useState([]);
    const [showAllBookings, setShowAllBookings] = useState(false);
    const [guestLimit, setGuestLimit] = useState(5);
    const [pastLimit, setPastLimit] = useState(5);
    const [guestBookings, setGuestBookings] = useState([]);
    const [showGuestBookings, setShowGuestBookings] = useState(false);
    const [booking, setBooking] = useState([]);
    const [showBooking, setShowBooking] = useState(false);
    const [values, setValues] = useState({ oldPassword: "", newPassword: "", newPassword1: "" });
    const [players, setPlayers] = useState([]);

    useEffect(() => {
        axios
            .get(`${API_BASE_URL}/api/players`, {
            })
            .then((response) => {
                setPlayers(response.data);
            })
            .catch((error) => {
            });
    }, []);

    const handleClick = (booking) => {
        setBooking(booking);
        setShowBooking(true);
    };

    const handleChangePassword = (values) => {
        if (values.newPassword === values.newPassword1) {

            const passwords = {
                currentPassword: values.oldPassword,
                newPassword: values.newPassword
            }

            axios
                .post(`${API_BASE_URL}/api/change-password`, passwords)
                .then((response) => {
                    toast.success(response.data.message);
                    setValues({ oldPassword: "", newPassword: "", newPassword1: "" });
                    setChangePassword(false);
                })
                .catch((error) => {
                    toast.error(error.response?.data?.message || "Fehler beim Passwort ändern")
                });
        } else {
            toast.error("Passwörter stimmen nicht überein")
        }
    }

    const fetchBookings = useCallback(() => {
        axios
            .get(`${API_BASE_URL}/api/${user.playerId}/bookings`)
            .then((response) => {
                const now = new Date();
                const upcoming = response.data
                    .filter(booking => new Date(booking.endTime) > now)
                    .sort((a, b) => new Date(a.startTime) - new Date(b.startTime));

                const past = response.data
                    .filter(booking => new Date(booking.endTime) <= now)
                    .sort((a, b) => new Date(b.startTime) - new Date(a.startTime));

                const guest = response.data
                    .filter(booking => booking.partners.includes(profile.guestId))
                    .sort((a, b) => new Date(b.startTime) - new Date(a.startTime));

                setUpcomingBookings(upcoming);
                setPastBookings(past);
                setGuestBookings(guest);

            })
            .catch((error) => {
            });
    }, [user.playerId, profile.guestId]);

    const handleClose = (value) => {
        if (value) {
            fetchBookings();
        }
        setShowBooking(false);
    }

    useEffect(() => {
        axios
            .get(`${API_BASE_URL}/api/profile`, {
            })
            .then((response) => {
                setProfile(response.data);
            })
            .catch((error) => {
            });
    }, []);

    useEffect(() => {
        fetchBookings();
    }, [fetchBookings]);



    if (!profile.player) {
        // Render nothing or a loading indicator if profile.player is not available
        return <div>Loading...</div>;
    }
    return (
        <Box>
            {/* Header Section */}
            <Paper 
                elevation={0}
                sx={{ 
                    p: { xs: 2, sm: 3 }, 
                    mb: 3, 
                    borderRadius: '12px', 
                    bgcolor: 'rgba(255, 255, 255, 0.9)', 
                    backdropFilter: 'blur(10px)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: { xs: 2, sm: 3 }
                }}
            >
                <Avatar 
                    sx={{ 
                        width: { xs: 50, sm: 80 }, 
                        height: { xs: 50, sm: 80 }, 
                        bgcolor: 'primary.main',
                        fontSize: { xs: '1.25rem', sm: '2rem' }
                    }}
                >
                    {profile.player.firstName?.charAt(0)}{profile.player.lastName?.charAt(0)}
                </Avatar>
                <Box>
                    <Typography 
                        variant="h4" 
                        color="primary" 
                        sx={{ 
                            fontSize: { xs: '1.25rem', sm: '1.75rem', md: '2.125rem' },
                            fontWeight: 500
                        }}
                    >
                        Hallo, {profile.player.firstName}!
                    </Typography>
                    <Typography 
                        variant="body2" 
                        color="text.secondary"
                        sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
                    >
                        Willkommen in deinem persönlichen Bereich.
                    </Typography>
                </Box>
            </Paper>

            <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                    <Paper 
                        elevation={0}
                        sx={{ 
                            p: 3, 
                            bgcolor: 'rgba(255, 255, 255, 0.9)',
                            backdropFilter: 'blur(10px)',
                            borderRadius: '12px'
                        }}
                    >
                        <Typography variant="subtitle1" color="primary.main" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                            <FaUserAlt size={18} /> Profildetails
                        </Typography>
                        
                        <Stack spacing={2} sx={{ mb: 4 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                <Avatar sx={{ width: 40, height: 40, bgcolor: 'rgba(0,0,0,0.05)', color: 'text.primary' }}>
                                    <FaUserAlt size={16} />
                                </Avatar>
                                <Box>
                                    <Typography variant="caption" color="text.secondary" display="block">Name</Typography>
                                    <Typography variant="body2" fontWeight="bold">{profile.player.firstName} {profile.player.lastName}</Typography>
                                </Box>
                            </Box>
                            
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                <Avatar sx={{ width: 40, height: 40, bgcolor: 'rgba(0,0,0,0.05)', color: 'text.primary' }}>
                                    <IoMdMail size={18} />
                                </Avatar>
                                <Box sx={{ minWidth: 0 }}>
                                    <Typography variant="caption" color="text.secondary" display="block">E-Mail</Typography>
                                    <Typography variant="body2" fontWeight="bold" noWrap title={profile.player.email}>{profile.player.email}</Typography>
                                </Box>
                            </Box>
                        </Stack>

                        {profile.familyMembers.length > 0 && (
                            <Box sx={{ mb: 4 }}>
                                <Typography variant="subtitle1" color="primary.main" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <MdFamilyRestroom size={20} /> Mitgliedschaft & Familie
                                </Typography>
                                <Stack spacing={1} sx={{ pl: 7 }}>
                                    {profile.familyMembers.map((member, index) => (
                                        <Typography key={index} variant="body2" color="text.secondary">
                                            • {member.firstName} {member.lastName}
                                        </Typography>
                                    ))}
                                </Stack>
                            </Box>
                        )}

                        <Typography variant="subtitle1" color="primary.main" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                            <FaReceipt size={18} /> Buchungs-Status
                        </Typography>
                        <Grid container spacing={2} sx={{ mb: 4 }}>
                            <Grid item xs={6}>
                                <Box sx={{ p: 1.5, bgcolor: 'rgba(0,0,0,0.02)', borderRadius: 2, textAlign: 'center' }}>
                                    <Typography variant="h5" color="primary.main">
                                        {upcomingBookings.length}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary">Aktive Buchungen</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={6}>
                                <Box sx={{ p: 1.5, bgcolor: 'rgba(0,0,0,0.02)', borderRadius: 2, textAlign: 'center' }}>
                                    <Typography variant="h5" color="primary.main">
                                        {guestBookings.length}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary">Gastbuchungen</Typography>
                                </Box>
                            </Grid>
                        </Grid>

                        <Typography variant="subtitle1" color="primary.main" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                            <MdLock size={20} /> Sicherheit
                        </Typography>
                        
                        {!changePassword ? (
                            <Button 
                                fullWidth 
                                variant="outlined" 
                                color="inherit" 
                                onClick={() => setChangePassword(true)}
                                sx={{ borderRadius: 2, textTransform: 'none' }}
                            >
                                Passwort ändern
                            </Button>
                        ) : (
                            <Stack spacing={2}>
                                <TextField
                                    id="oldPassword"
                                    label="Altes Passwort"
                                    type="password"
                                    fullWidth
                                    value={values.oldPassword}
                                    onChange={e => setValues({ ...values, oldPassword: e.target.value })}
                                />
                                <TextField
                                    id="newPassword"
                                    label="Neues Passwort"
                                    type="password"
                                    fullWidth
                                    value={values.newPassword}
                                    onChange={e => setValues({ ...values, newPassword: e.target.value })}
                                />
                                <TextField
                                    id="newPassword1"
                                    label="Wiederholen"
                                    type="password"
                                    fullWidth
                                    value={values.newPassword1}
                                    onChange={e => setValues({ ...values, newPassword1: e.target.value })}
                                />
                                <Stack direction="row" spacing={1}>
                                    <Button variant="contained" color="primary" fullWidth onClick={() => handleChangePassword(values)} sx={{ borderRadius: 2 }}>
                                        Speichern
                                    </Button>
                                    <Button variant="text" color="inherit" onClick={() => setChangePassword(false)}>
                                        Abbruch
                                    </Button>
                                </Stack>
                            </Stack>
                        )}
                    </Paper>
                </Grid>

                <Grid item xs={12} md={8}>
                    <Paper 
                        elevation={0}
                        sx={{ 
                            p: 3, 
                            bgcolor: 'rgba(255, 255, 255, 0.9)',
                            backdropFilter: 'blur(10px)',
                            borderRadius: '12px'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 3 }}>
                            <Typography variant="h6" color="primary.main">
                                {showGuestBookings ? "Meine Gastbuchungen" : showAllBookings ? "Vergangene Buchungen" : "Aktuelle Buchungen"}
                            </Typography>
                            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                                <Button 
                                    size="small" 
                                    variant={!showGuestBookings && !showAllBookings ? "contained" : "text"}
                                    onClick={() => { setShowGuestBookings(false); setShowAllBookings(false); }}
                                >
                                    Aktuell
                                </Button>
                                <Button 
                                    size="small" 
                                    variant={showGuestBookings ? "contained" : "text"}
                                    onClick={() => { setShowGuestBookings(true); setShowAllBookings(false); }}
                                >
                                    Gast
                                </Button>
                                <Button 
                                    size="small" 
                                    variant={showAllBookings ? "contained" : "text"}
                                    onClick={() => { setShowGuestBookings(false); setShowAllBookings(true); }}
                                >
                                    Historie
                                </Button>
                            </Box>
                        </Box>

                        <Stack spacing={2}>
                            {showGuestBookings ? (
                                guestBookings.length !== 0 ? (
                                    <>
                                        {guestBookings.slice(0, guestLimit).map((booking, index) => (
                                            <Paper
                                                key={index}
                                                elevation={0}
                                                onClick={() => handleClick(booking)}
                                                sx={{
                                                    p: 2,
                                                    borderRadius: '12px',
                                                    cursor: 'pointer',
                                                    bgcolor: 'rgba(0,0,0,0.02)',
                                                    border: '1px solid rgba(0,0,0,0.05)',
                                                    '&:hover': { bgcolor: 'rgba(0,0,0,0.04)', transform: 'translateY(-2px)' },
                                                    transition: 'all 0.2s'
                                                }}
                                            >
                                                <Grid container alignItems="center" spacing={2}>
                                                    <Grid item xs={12} sm={3}>
                                                        <Typography variant="body2" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                            <FaCalendar size={14} color="gray" /> {dayjs(booking.startTime).tz().format("DD.MM.YYYY")}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={4}>
                                                        <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                            <FaClock size={14} color="gray" /> {dayjs(booking.startTime).tz().format("HH:mm")} - {dayjs(booking.endTime).tz().format("HH:mm")} Uhr
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={6} sm={2} sx={{ textAlign: { xs: 'left', sm: 'center' } }}>
                                                        <Chip 
                                                            icon={<RiMoneyEuroCircleFill size={16} />} 
                                                            label={booking.guestPlayerpayed ? "Bezahlt" : "Offen"} 
                                                            size="small"
                                                            color={booking.guestPlayerpayed ? "success" : "error"}
                                                            variant="outlined"
                                                        />
                                                    </Grid>
                                                    <Grid item xs={6} sm={3} sx={{ textAlign: 'right' }}>
                                                        {booking.status === 1 ? (
                                                            <Chip label="Storniert" size="small" color="error" />
                                                        ) : (
                                                            <Chip label="Gast" size="small" variant="outlined" />
                                                        )}
                                                    </Grid>
                                                </Grid>
                                            </Paper>
                                        ))}
                                        {guestBookings.length > guestLimit && (
                                            <Button 
                                                variant="text" 
                                                fullWidth 
                                                onClick={() => setGuestLimit(prev => prev + 5)}
                                                sx={{ mt: 1, textTransform: 'none' }}
                                            >
                                                Mehr Gastbuchungen anzeigen...
                                            </Button>
                                        )}
                                    </>
                                ) : (
                                    <Box sx={{ textAlign: 'center', py: 8, opacity: 0.5 }}>
                                        <FaSuitcaseRolling size={40} style={{ marginBottom: 16 }} />
                                        <Typography variant="body1">Keine Gastbuchungen vorhanden.</Typography>
                                    </Box>
                                )
                            ) : (
                                <>
                                    {showAllBookings ? (
                                        pastBookings.length !== 0 ? (
                                            <>
                                                {pastBookings.slice(0, pastLimit).map((booking, index) => (
                                                    <Paper
                                                        key={`past-${index}`}
                                                        elevation={0}
                                                        onClick={() => handleClick(booking)}
                                                        sx={{
                                                            p: 2,
                                                            borderRadius: '12px',
                                                            cursor: 'pointer',
                                                            bgcolor: 'rgba(0,0,0,0.02)',
                                                            border: '1px solid rgba(0,0,0,0.05)',
                                                            opacity: 0.8,
                                                            '&:hover': { bgcolor: 'rgba(0,0,0,0.04)', transform: 'translateY(-2px)' },
                                                            transition: 'all 0.2s'
                                                        }}
                                                    >
                                                        <Grid container alignItems="center" spacing={2}>
                                                            <Grid item xs={12} sm={3}>
                                                                <Typography variant="body2" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                    <FaCalendar size={14} color="gray" /> {dayjs.tz(booking.startTime).format("DD.MM.YYYY")}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={12} sm={4}>
                                                                <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                    <FaClock size={14} color="gray" /> {dayjs.tz(booking.startTime).format("HH:mm")} - {dayjs.tz(booking.endTime).format("HH:mm")} Uhr
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={6} sm={2} sx={{ textAlign: { xs: 'left', sm: 'center' } }}>
                                                                <Typography variant="body2" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', justifyContent: { xs: 'flex-start', sm: 'center' }, gap: 1 }}>
                                                                    <GiTennisCourt size={18} /> {booking.courtId}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={6} sm={3} sx={{ textAlign: 'right' }}>
                                                                {booking.status === 1 ? (
                                                                    <Chip label="Storniert" size="small" color="error" />
                                                                ) : (
                                                                    <Chip label="Vergangen" size="small" variant="outlined" sx={{ opacity: 0.6 }} />
                                                                )}
                                                            </Grid>
                                                        </Grid>
                                                    </Paper>
                                                ))}
                                                {pastBookings.length > pastLimit && (
                                                    <Button 
                                                        variant="text" 
                                                        fullWidth 
                                                        onClick={() => setPastLimit(prev => prev + 5)}
                                                        sx={{ mt: 1, textTransform: 'none' }}
                                                    >
                                                        Mehr vergangene Buchungen anzeigen...
                                                    </Button>
                                                )}
                                            </>
                                        ) : (
                                            <Box sx={{ textAlign: 'center', py: 8, opacity: 0.5 }}>
                                                <FaCalendar size={40} style={{ marginBottom: 16 }} />
                                                <Typography variant="body1">Keine vergangenen Buchungen gefunden.</Typography>
                                            </Box>
                                        )
                                    ) : (
                                        upcomingBookings.length !== 0 ? upcomingBookings.map((booking, index) => (
                                            <Paper
                                                key={`up-${index}`}
                                                elevation={0}
                                                onClick={() => handleClick(booking)}
                                                sx={{
                                                    p: 2,
                                                    borderRadius: '12px',
                                                    cursor: 'pointer',
                                                    bgcolor: 'rgba(0,0,0,0.02)',
                                                    border: '1px solid rgba(0,0,0,0.05)',
                                                    '&:hover': { bgcolor: 'rgba(0,0,0,0.04)', transform: 'translateY(-2px)' },
                                                    transition: 'all 0.2s'
                                                }}
                                            >
                                                <Grid container alignItems="center" spacing={2}>
                                                    <Grid item xs={12} sm={3}>
                                                        <Typography variant="body2" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                            <FaCalendar size={14} color="gray" /> {dayjs(booking.startTime).tz().format("DD.MM.YYYY")}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={4}>
                                                        <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                            <FaClock size={14} color="gray" /> {dayjs(booking.startTime).tz().format("HH:mm")} - {dayjs(booking.endTime).tz().format("HH:mm")} Uhr
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={6} sm={2} sx={{ textAlign: { xs: 'left', sm: 'center' } }}>
                                                        <Typography variant="body2" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', justifyContent: { xs: 'flex-start', sm: 'center' }, gap: 1 }}>
                                                            <GiTennisCourt size={18} /> {booking.courtId}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={6} sm={3} sx={{ textAlign: 'right' }}>
                                                        {booking.status === 1 ? (
                                                            <Chip label="Storniert" size="small" color="error" />
                                                        ) : (
                                                            <Chip label="Anstehend" size="small" color="success" variant="outlined" />
                                                        )}
                                                    </Grid>
                                                </Grid>
                                            </Paper>
                                        )) : (
                                            <Box sx={{ textAlign: 'center', py: 8, opacity: 0.5 }}>
                                                <FaCalendar size={40} style={{ marginBottom: 16 }} />
                                                <Typography variant="body1">Keine anstehenden Buchungen.</Typography>
                                            </Box>
                                        )
                                    )}
                                </>
                            )}
                        </Stack>
                    </Paper>
                </Grid>
            </Grid>
            {showBooking && <ShowBookingModal show={showBooking} onHide={handleClose} booking={booking} players={players} />}
        </Box>
    );
}

export default Account;